import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { FileTypeCopySink } from './../../../pipeline/copysink/file-type.copysink';
import { Model } from 'app/model/backendmodel';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';

export abstract class FileTypeSinkAdapter<T, U> extends CopySinkAdapter<T, U> {
    public static toSinkResource(model: FileTypeCopySink, resource: Model.CopySink): void {
        if (resource != null) {
            resource.copyBehavior = ValueAdapter.toResource(model, FileTypeCopySink.COPY_BEHAVIOR);
            CopySinkAdapter.maxConcurrentConnectionsToResource(model, resource);
        }
    }

    public static toSinkModel(resource: Model.CopySink, model: FileTypeCopySink): void {
        if (model != null) {
            ValueAdapter.toModel(model, FileTypeCopySink.COPY_BEHAVIOR, resource.copyBehavior);
            CopySinkAdapter.maxConcurrentConnectionsToModel(resource, model);
        }
    }
}
